import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../../sections/header';
import PostCard from '../../sections/post-card';
import * as popups from '../../../../constants/popup-types';
import * as routes from '../../../../constants/routes';
import { addPopup, forumFindOnePost } from '../../../../redux/actions';
import './index.scss';

const PostRoute = () => {
  const { postId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const { forumConfiguration } = useSelector((store) => store.config.Parameters);
  const translations = useSelector((store) => store.config.Translations);

  const [postData, setPostData] = useState({});
  const [isLoadingPost, setIsLoadingPost] = useState(true);

  const fetchPostData = () => {
    setPostData({});
    setIsLoadingPost(true);

    dispatch(forumFindOnePost(
      // General Configuration
      postId,
      forumConfiguration,

      // Handle Success
      (response) => {
        if (response.data) {
          setPostData({ ...response.data });
          setIsLoadingPost(false);
          return;
        }

        handlePostNotFoundError();
      },

      // Handle Failure
      handlePostNotFoundError,
    ));
  };

  const handlePostNotFoundError = () => dispatch(addPopup({
    type: popups.GENERAL_MESSAGE,
    text: translations['forum_post_route_not_found_message'],
    btnText: translations['forum_post_route_not_found_button'],
    action: () => history.push(routes.forum),
  }));

  useEffect(fetchPostData, [postId]);

  return (
    <div className="forum-post-route">
      <Header
        title={translations['forum_post_route_header_title']}
        additionalBreadcrumb={{
          text: translations['forum_post_route_breadcrumb'],
          route: routes.forum + routes.forum_routes.base_route,
        }}
      />

      <div className="post-container">
        <Link to={routes.forum} className="get-back-jojo">
          {translations['forum_post_route_get_back_link']}
        </Link>

        {isLoadingPost ? (
          <PostCard isSkeleton />
        ) : (
          <PostCard postData={postData} isSelected disableSelectOption />
        )}
      </div>
    </div>
  );
};

export default PostRoute;
